export default "/kiban/_next/static/images/minPattern-362aaf2242a3228f8dbbda45c6e6f3f2.png";